<app-titledescription
  [title]="'Competencias'"
  [description]="'Aca se muestra competencias de la persona ingresada'"
></app-titledescription>
<ng-template #filterTitulo class="flex">
  <app-input
    class="py-4"
    [label]="'Ingrese Dni'"
    [type]="'number'"
    (inputValue)="dni = $event"
    (keydown.enter)="searchTitulos($event)"
  ></app-input>
  <div class="py-6">
    <app-button
      class="mr-2"
      [text]="'Buscar'"
      [typeButton]="'button'"
      (click)="searchTitulos()"
    ></app-button>
    @if (titulosByDniData) {
      <app-button
        [text]="'Descargar PDF General'"
        [typeButton]="'button'"
        (click)="downloadAllCompetenciasPDF()"
        [color]="'warn'"
        [isDisabled]="isLoadingPDF()"
      ></app-button>
    }
  </div>
</ng-template>

<ng-template #tableCompetencias>
  @if(isLoading) {
    <mat-spinner></mat-spinner>
  }
  @else if (dataFetchCompetencias && dataFetchCompetencias.length > 0) {
    <table
      mat-table
      [dataSource]="dataFetchCompetencias"
      multiTemplateDataRows
      class="mat-elevation-z8 w-full"
    >
      <ng-container matColumnDef="nivelDescripcion">
        <th mat-header-cell *matHeaderCellDef class="font-bold">
          <strong>Competencias Por Nivel</strong>
        </th>
        <td mat-cell *matCellDef="let grupo">
          {{ grupo.nivelDescripcion || grupo.nivel || 'Sin nivel' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let grupo">
          <button
            mat-icon-button
            (click)="toggleNivel(grupo.nivel); $event.stopPropagation()"
            class="example-toggle-button"
            [class.example-toggle-button-expanded]="isNivelExpanded(grupo.nivel)"
          >
            <mat-icon
              [ngClass]="{ 'example-toggle-button-expanded': isNivelExpanded(grupo.nivel) }"
            >
              {{ isNivelExpanded(grupo.nivel) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let grupo" [attr.colspan]="2">
          <div
            class="example-element-detail-wrapper"
            [class.example-element-detail-wrapper-expanded]="isNivelExpanded(grupo.nivel)"
          >
            <div class="example-element-detail">
              <div *ngIf="isNivelExpanded(grupo.nivel)">
                <table mat-table [dataSource]="grupo.competencias" class="mat-elevation-z1 w-full">
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>Código</th>
                    <td mat-cell *matCellDef="let comp">{{ comp.materia.codigo }}</td>
                  </ng-container>
                  <ng-container matColumnDef="descripcion">
                    <th mat-header-cell *matHeaderCellDef>Descripción</th>
                    <td mat-cell *matCellDef="let comp">{{ comp.materia.descripcion }}</td>
                  </ng-container>
                  <ng-container matColumnDef="fecha_alta">
                    <th mat-header-cell *matHeaderCellDef>Fecha Alta</th>
                    <td mat-cell *matCellDef="let comp">
                      {{ comp.fecha_alta ? (comp.fecha_alta | date: 'yyyy-MM-dd') : '-' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="fecha_baja">
                    <th mat-header-cell *matHeaderCellDef>Fecha Baja</th>
                    <td mat-cell *matCellDef="let comp">
                      {{ comp.fecha_baja ? (comp.fecha_baja | date: 'yyyy-MM-dd') : '-' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="caracter">
                    <th mat-header-cell *matHeaderCellDef>Carácter</th>
                    <td mat-cell *matCellDef="let comp">
                      {{ comp.titulo.caracter.descripcion || '-' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="observacion">
                    <th mat-header-cell *matHeaderCellDef>Observación</th>
                    <td mat-cell *matCellDef="let comp">{{ comp.observacion }}</td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="[
                      'id',
                      'descripcion',
                      'fecha_alta',
                      'fecha_baja',
                      'caracter',
                      'observacion',
                    ]"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="
                      let comp;
                      columns: [
                        'id',
                        'descripcion',
                        'fecha_alta',
                        'fecha_baja',
                        'caracter',
                        'observacion',
                      ]
                    "
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['nivelDescripcion', 'expand']"></tr>
      <tr
        mat-row
        *matRowDef="let grupo; columns: ['nivelDescripcion', 'expand']"
        class="example-element-row"
        [class.example-expanded-row]="isNivelExpanded(grupo.nivel)"
        (click)="toggleNivel(grupo.nivel)"
      ></tr>
      <tr
        mat-row
        *matRowDef="let grupo; columns: ['expandedDetail']"
        class="example-detail-row"
      ></tr>
    </table>
  } @else {
    <span>No hay competencias para mostrar.</span>
  }

</ng-template>
<ng-template #tableTitulos>
  <div class="container">
    @if (titulosByDniData && titulosUsuarioByDniData) {
      <h1 class="text-xl mb-2 text-gray-700 bg-gray-300 rounded-lg text-center p-1">
        Títulos Media
      </h1>
      <app-table
        [height]="'550px'"
        [columnsNames]="columnNamesTitulos"
        [dataFetch]="titulosByDniData"
        [totalItems]="0"
        (fetchAgain)="getTitulosMediaByDni( $event.options, $event.ignoreCache)"
        [actions]="actionsTitulos"
        (callCustomFunction)="openModal($event)"
        [templateRef]="tableCompetencias"
      ></app-table>

      <h1 class="text-xl mb-2 text-gray-700 bg-gray-300 rounded-lg text-center p-1">
        Títulos Portal
      </h1>
      <div class="container">
        <app-table
          [columnsNames]="columnNamesTitulosUsuario"
          [dataFetch]="titulosUsuarioByDniData"
          [totalItems]="titulosUsuarioByDniData.total_items"
          [pagination]="true"
          (callCustomFunction)="openModal($event)"
          (fetchAgain)="getTitulosPortalByDni($event.options, $event.ignoreCache)"
          [apiService]="tituloUsuarioService"
        ></app-table>
      </div>
      }
    @if (isLoading) {
      <mat-spinner></mat-spinner>
    }
  </div>
</ng-template>
<app-card [templateRefHeader]="filterTitulo" [templateRefContent]="tableTitulos"></app-card>
